import * as transactionsActions from '../actions/transactions';

const defaultState = {};

// eslint-disable-next-line default-param-last
const transactions = (state = defaultState, action) => {
  switch (action.type) {
    case transactionsActions.GET_TRANSACTIONS: {
      const { getTransactionsError, ...newState } = state;
      return {
        ...newState,
        gettingTransactions: true,
      };
    }
    case transactionsActions.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: action.payload,
        gettingTransactions: false,
      };
    case transactionsActions.GET_TRANSACTIONS_ERROR:
      return {
        ...state,
        getTransactionsError: action.payload,
        gettingTransactions: false,
      };
    case transactionsActions.GET_TRANSACTIONS_SUMMARY: {
      const { getTransactionsSummaryError, transactionsSummary, ...newState } = state;
      return {
        ...newState,
        gettingTransactionsSummary: true,
      };
    }
    case transactionsActions.GET_TRANSACTIONS_SUMMARY_SUCCESS:
      return {
        ...state,
        transactionsSummary: action.payload,
        gettingTransactionsSummary: false,
      };
    case transactionsActions.GET_TRANSACTIONS_SUMMARY_ERROR:
      return {
        ...state,
        getTransactionsSummaryError: action.payload,
        gettingTransactionsSummary: false,
      };
    default:
      return state;
  }
};

export default transactions;
